module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres35u-popup-approve",
      "id": "hres35u-popup-approve",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    ref: "popupApproveModalButton",
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['0']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.approve.codempid) + _vm._s(_vm.approve.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "approvno",
      "name": "approvno"
    }
  }, [_vm._v(_vm._s(_vm.indexSelected.approvno))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codappr",
      "name": "coddesc_codappr"
    }
  }, [_vm._v(_vm._s(_vm.approve.codappr) + _vm._s(_vm.approve.desc_codappr))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "currentDate",
      "has-error": _vm.errors.has('currentDate')
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:currentDate'),
      expression: "'required|date_format:DD/MM/YYYY|after:currentDate'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteappr",
      "has-error": _vm.errors.has('dteappr')
    },
    model: {
      value: (_vm.approve.dteappr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dteappr", $$v)
      },
      expression: "approve.dteappr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteappr')),
      expression: "errors.has('dteappr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteappr')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:dteappr'),
      expression: "'required|date_format:DD/MM/YYYY|after:dteappr'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteeffec",
      "has-error": _vm.errors.has('dteeffec')
    },
    model: {
      value: (_vm.approve.dteeffec),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dteeffec", $$v)
      },
      expression: "approve.dteeffec"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteeffec')),
      expression: "errors.has('dteeffec')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteeffec')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.arrCodmov[_vm.nowLang],
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codmov",
      "has-error": _vm.errors.has('codmov')
    },
    model: {
      value: (_vm.approve.codmov),
      callback: function($$v) {
        _vm.$set(_vm.approve, "codmov", $$v)
      },
      expression: "approve.codmov"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codmov')),
      expression: "errors.has('codmov')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codmov')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "status",
      "name": "status"
    }
  }, [_vm._v(_vm._s(_vm.approve.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC2']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.remark),
      expression: "approve.remark"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:500'),
      expression: "'max:500'"
    }],
    staticClass: "textarea-text width-70",
    attrs: {
      "id": "remark",
      "name": "remark",
      "maxlength": "500",
      "data-vv-name": "remark",
      "has-error": _vm.errors.has('remark')
    },
    domProps: {
      "value": (_vm.approve.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer align-center border-color-skin"
  }, [_c('button', {
    staticClass: "btn bg-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.validatePopupApprove()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['approve']))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c6da4a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres35u/popupApprove.vue
// module id = 3698
// module chunks = 1